"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Glow() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="14772" id="ready-for-your-glow" className="relative bg-background text-foreground py-28 md:py-36 overflow-hidden">
      <div className="mx-auto max-w-[1080px] px-6 md:px-12">
        <div ref={ref} className="relative" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 900ms cubic-bezier(0.22, 0.61, 0.36, 1), transform 900ms cubic-bezier(0.22, 0.61, 0.36, 1)"
      }}>
          {}
          <div aria-hidden="true" className="absolute -right-20 top-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-lg pointer-events-none" style={{
          background: "radial-gradient(circle, hsl(15 45% 75% / 0.2) 0%, transparent 70%)",
          filter: "blur(80px)"
        }} />

          <div className="relative rounded-3xl px-8 py-12 sm:px-12 sm:py-16 md:px-20 md:py-24 text-center border border-primary/20" style={{
          backgroundColor: "hsl(30 10% 92% / 0.5)"
        }}>
            <h2 className="font-default text-foreground mx-auto max-w-3xl" style={{
            fontSize: "clamp(2.1rem, 3.8vw, 3.5rem)",
            fontWeight: 500,
            lineHeight: 1.08,
            letterSpacing: "-0.018em"
          }}>
              <span>Ready for your </span>
              <span className="relative inline-block">
                <em className="italic font-serif font-normal">refined</em>
                <svg aria-hidden="true" className="absolute left-0 -bottom-1 w-full" viewBox="0 0 100 8" preserveAspectRatio="none" style={{
                height: "8px"
              }}>
                  <path d="M 2 5 Q 15 1, 30 4 T 60 4 T 98 4" fill="none" stroke="hsl(15 45% 75%)" strokeWidth="2" strokeLinecap="round" style={{
                  strokeDasharray: 120,
                  strokeDashoffset: isVisible ? 0 : 120,
                  transition: "stroke-dashoffset 900ms ease-out 600ms"
                }} />
                </svg>
              </span>
              <span> glow?</span>
            </h2>

            <p className="font-default text-muted-foreground mt-6 mx-auto" style={{
            fontSize: "clamp(1.125rem, 1.15vw, 1.25rem)",
            lineHeight: 1.65,
            letterSpacing: "-0.003em",
            maxWidth: "540px"
          }}>
              Experience concierge facial balancing designed to restore symmetry and enhance your natural beauty with precision and care.
            </p>

            <div className="mt-10">
              <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg font-default font-medium shadow-sm transition-colors duration-300 px-8 sm:px-10 w-full sm:w-auto" style={{
              minHeight: "60px",
              fontSize: "1rem"
            }}>
                <Link to="https://my.portraitcare.com/booking/?business_id=jr3uOp" newTab>Schedule your consultation</Link>
              </Button>
            </div>

            <p className="mt-6 font-default text-muted-foreground" style={{
            fontSize: "0.875rem",
            lineHeight: 1.5
          }}>
              Private concierge service · Expert clinical care
            </p>
          </div>
        </div>
      </div>
    </section>;
}